import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/Auth/LoginForm';
import { useAuth } from '../components/Auth/AuthContext';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  // Эффект для перенаправления при успешной аутентификации
  useEffect(() => {
    if (isAuthenticated) {
      console.log('🚀 Пользователь аутентифицирован, перенаправление...');
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleLoginSuccess = (userData) => {
    console.log('🚀 Успешный вход, данные:', userData);
    window.location.reload();
    // После успешного входа состояние isAuthenticated изменится,
    // и сработает useEffect выше
  };

  // Если уже аутентифицирован, сразу перенаправляем
  useEffect(() => {
    if (isAuthenticated) {
      console.log('🚀 Уже аутентифицирован, перенаправление...');
      navigate('/dashboard', { replace: true });
    }
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    }}>
      <LoginForm onLoginSuccess={handleLoginSuccess} />
    </div>
  );
};

export default LoginPage;
